import { render, staticRenderFns } from "./ListActions.vue?vue&type=template&id=cd2463e2&"
import script from "./ListActions.vue?vue&type=script&lang=ts&"
export * from "./ListActions.vue?vue&type=script&lang=ts&"
import style0 from "./ListActions.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports